class PriceButton extends HTMLElement {
  constructor() {
    super();
    this.currency = window.Shopify.currency.active || 'USD';
    this.language = window.Shopify.locale || 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) {
      console.warn('no found button inside <price-button>');
      return;
    }

    this.priceEl = this.querySelector('[data-price-original]');
    this.strikeEl = this.querySelector('[data-price-compare]');
    this.discount = this.loadDiscount(this);

    this.loadVariantsData('#product-variants-data');

    /* variant change normal - product with variants */
    document.addEventListener('variant::change', (event) => {
      const { variantId, sellingPlan, qtyTotal } = event.detail;
      this.updatePrices(variantId, sellingPlan);
    });

    /* product with subscription - change subscription */
    document.addEventListener('skio::update-selling-plan', (event) => {
      const { variant, sellingPlan  } = event.detail;
      if (variant?.id) this.updatePrices(variant.id, sellingPlan);
    });

    /* product pair */
    document.addEventListener('variant-pair:selected', (e) => {
      const { variantId, isChecked } = e.detail;
      if (!variantId) return;

      const elementData = document.querySelector('#product-variants-pair');

      if (isChecked) {
        this.discount = this.loadDiscount(elementData);
        this.loadVariantsData('#product-variants-pair');
      } else {
        this.discount = this.loadDiscount(this);
        this.loadVariantsData('#product-variants-data');
      }

      this.updatePrices(variantId);
    });
  }

  loadDiscount(element) {
    return parseFloat(element.dataset.discountMetafield || 0);
  }

  loadVariantsData(selector = '#product-variants-data') {
    const variantsEl = document.querySelector(selector);
    if (!variantsEl) {
      console.warn('⚠️ no data variants');
      return;
    }

    this.variants = JSON.parse(variantsEl.textContent);
  }

  updatePrices(variantId, sellingPlan = null) {
    if (!this.variants || !Array.isArray(this.variants)) return;

    const variant = this.variants.find(v => v.id == variantId);

    if (!variant) return;

    const basePrice = variant.price;
    const comparePrice = variant.compare_at_price || 0;
    const hasShopifyDiscount = comparePrice > basePrice;

    let finalPrice = basePrice;
    let showCompare = false;

    if (sellingPlan && variant.selling_plan_allocations?.length) {

      const allocation = variant.selling_plan_allocations.find(
        alloc => alloc.selling_plan_id === sellingPlan.id
      );
      if (allocation) {
        finalPrice = allocation.price;
        showCompare = true;
      }
    }

    if (this.discount > 0 && !sellingPlan) {
      finalPrice = basePrice - basePrice * (this.discount / 100);
      showCompare = true;
    } else if (hasShopifyDiscount) {
      showCompare = true;
    }

    if (this.priceEl) {
      this.priceEl.textContent = `- ${this.moneyFormatter.format(finalPrice / 100).replace('.00', '')}`;
    }

    if (this.strikeEl) {
      if (showCompare) {
        const compareValue = comparePrice > basePrice ? comparePrice : basePrice;
        this.strikeEl.textContent = this.moneyFormatter.format(compareValue / 100).replace('.00', '');
        this.strikeEl.classList.remove('hidden');
      } else {
        this.strikeEl.classList.add('hidden');
      }
    }

    const label = this.button.querySelector('span:first-child');
    const labelTextPrice = this.button.querySelector('.label-change-text');
    const labelTextContent = this.button.querySelector('[data-text-content]');
    
    if (label) {
      label.textContent = variant.available ? 'Add to cart' : 'Join the waitlist -';
    }

    if (labelTextPrice) {
      labelTextPrice.textContent = variant.available ? 'Add to cart ' : 'Join the waitlist ';
    }

    if (labelTextContent) {
      labelTextContent.innerHTML = variant.available ? this.button.dataset.textAvailable : this.button.dataset.textUnavailable;
    }

    this.dispatchEvent(
      new CustomEvent('price-updated', {
        bubbles: true,
        detail: {
          variantId,
          sellingPlan,
          basePrice,
          comparePrice,
          finalPrice,
          discountApplied: this.discount,
        },
      })
    );
  }
}

customElements.define('price-button', PriceButton);
